import { makeStyles } from '@material-ui/core'

export const useAttendeeListingStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  button: {
    minWidth: '250px'
  },
  select: {
    minWidth: '200px'
  },
  filterDropdown: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  filterLabel: {
    width: '100%',
    fontSize: '1rem',
    textAlign: 'right',
    marginRight: '8px',
    fontWeight: 'bold'
  },
  downloadCSV: { width: '100%', paddingLeft: '1.25rem' },
  selectBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  },
  iconBtn: {
    padding: '4px'
  },
  icon: {
    fontSize: '18px'
  },
  actionBtns: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  flexBox: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center'
  },
  filterStatsBar: {
    marginTop: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    borderRadius: '8px',
    border: '1px solid rgba(0, 0, 0, 0.04)',
    margin: '0px 8px 16px 8px'
  },
  statsChips: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  statsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  statChipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  statChip: {
    fontSize: '15px',
    padding: '4px 8px',
    letterSpacing: '0.5px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)'
    }
  },
  activeChip: {
    fontSize: '15px',
    letterSpacing: '0.5px',
    padding: '4px 8px',
    backgroundColor: `${theme?.palette?.primary?.main || '#1976d2'} !important`,
    color: 'white',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: theme?.palette?.primary?.dark || '#115293'
    }
  },
  clearButton: {
    whiteSpace: 'nowrap'
  },
  // Badge printing styles
  pdfForm: {
    marginTop: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
    marginBottom: '1rem'
  },
  buttonBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  modalButton: {
    textTransform: 'none',
    letterSpacing: '1px',
    fontSize: '1rem'
  },
  downloadCircle: {
    marginLeft: '0.75rem'
  },
  modalHeader: {
    padding: '4px 20px',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  iconButton: {
    padding: '8px',
    position: 'absolute',
    right: 8,
    top: 8
  },
  deleteDialogHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    paddingBottom: '4px'
  },
  deleteIconCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#fdecea',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  deleteDialogTitle: {
    flex: 1,
    fontWeight: 600
  },
  deleteDialogClose: {
    marginLeft: 'auto',
    color: theme.palette.text.secondary
  },
  deleteDialogContent: {
    paddingTop: '4px !important'
  },
  deleteWarningBox: {
    marginTop: 12,
    padding: '10px 14px',
    backgroundColor: '#fff8e1',
    border: '1px solid #ffe082',
    borderRadius: 6,
    color: '#795548',
    '& .MuiTypography-root': {
      fontWeight: 500
    }
  },
  deleteDialogActions: {
    padding: '16px 24px',
    gap: 10
  }
}))
